import { DialogTitle, Divider, GridProps, useTheme } from '@mui/material';
import { ContextForm, IFormAfterSubmit, InputOnlyField, Text } from '@ngt/forms';
import { ValidateOn } from '@ngt/forms-core';
import { FC, useCallback, useContext } from 'react';
import { Project } from '../../api/dtos';
import PropertiesContext from '../../contexts/PropertiesContext';
import { IFormDialogProps, StyledButton, StyledDialog, StyledDialogActions, StyledDialogContent, StyledFormColumn, StyledFormSubmitButton } from '../inputs/CommonFormElements';

const COLUMN_SIZING: GridProps['size'] = {
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    xl: 6
} 

const PropertyForm: FC<IFormDialogProps> = (props) => {
    const theme = useTheme();
    const { refresh: refreshProperties } = useContext(PropertiesContext);
    

    const onAfterSubmit: IFormAfterSubmit<Project> = useCallback(async (_newValue, _formState, _formActions) => {
        await refreshProperties();
        props.onClose();
    }, [refreshProperties, props.onClose])

    return (
        <ContextForm
            onAfterSubmit={onAfterSubmit}
            validateOn={ValidateOn.onChange}
            validateOnReset
        >
            <StyledDialog {...props}>
                <DialogTitle
                    sx={{
                        backgroundColor: theme.palette.secondary.light,
                        color: "white"
                    }}
                >
                    {props.edit ? "Edit" : "Add"} Property
                </DialogTitle>
                <StyledDialogContent>
                    <StyledFormColumn
                        size={COLUMN_SIZING}
                    >
                        <InputOnlyField 
                            label="Name"
                            component={Text}
                            propertyPath={'name'}
                        />
                        <InputOnlyField 
                            label="Rank"
                            component={Text}
                            propertyPath={'rank'}
                        />
                    </StyledFormColumn>
                </StyledDialogContent>
                <Divider />
                <StyledDialogActions>
                    <StyledFormSubmitButton variant="contained">Submit</StyledFormSubmitButton>
                    <StyledButton variant="contained" onClick={props.onClose}>Cancel</StyledButton>
                </StyledDialogActions>
            </StyledDialog>
        </ContextForm>
    );
}

export default PropertyForm;